const ACTIVE_STATUS = "ACTIVE";
const CANCELLED_STATUS = "CANCELLED";

export const normalizeSubscriptionStatus = (
  subscription,
  now = Date.now()
) => {
  if (
    !subscription ||
    subscription.status !== ACTIVE_STATUS ||
    subscription.autoRenew !== false ||
    !subscription.currentPeriodEnd
  ) {
    return subscription;
  }

  const periodEnd = Date.parse(subscription.currentPeriodEnd);
  const referenceTime = now instanceof Date ? now.getTime() : Number(now);

  if (
    !Number.isFinite(periodEnd) ||
    !Number.isFinite(referenceTime) ||
    periodEnd > referenceTime
  ) {
    return subscription;
  }

  return {
    ...subscription,
    status: CANCELLED_STATUS,
  };
};
